export const partner = 'ascm';

export const microSites: string[] = [];
export function sideEffects() {}

export const tiers = {
	is2024: /2024/,
	isDemo: /ss|demo/,
	isPreview: /ascmpreview/
};

export const flags = ({ is2024, isDemo, isPreview }: Record<string, boolean>) => [
	['ati-use-single-rpc', !isDemo],
	['has-announcements', !isDemo],
	['posttest', !is2024],
	['practice-exam', !is2024],
	['quiz-progress-chart', true],
	['use-alternate-next', true],
	['use-alternate-pass-view', !is2024],
	['use-assessment-chooser', !is2024],
	['use-audio-topics', !is2024],
	['use-carousel-view', !is2024],
	['use-cutscores', false],
	['use-landing-page', !is2024],
	['use-search-in-heading', true],
	['use-study-plan', !is2024],
	['use-toc', !is2024],
	['use-topicgroup-quiz', false],
	['use-topicgroup-reading', !is2024],
	['use-wylo', !is2024 && !isPreview],
	['use-xapi', !is2024]
];
